import React from "react";

import Elements from "../";

const LimitedInTime = ({ start, end, nestedElements, defaultElements }) => {
    if (
        (start ? new Date(parseInt(start)) <= new Date() : true) &&
        (end ? new Date() <= new Date(parseInt(end)) : true)
    ) {
        return <Elements elements={nestedElements} />;
    }
    return defaultElements && <Elements elements={defaultElements} />;
};

export default LimitedInTime;
